import { Component, OnInit } from '@angular/core';
import { AdminAboutData, AdminApiService } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-about',
    templateUrl: './admin-about.component.html'
})
export class AdminAboutComponent implements OnInit {

    data: AdminAboutData = null as any;

    hero: any = {
        id: 0,
        eyebrow: '',
        title: '',
        description: '',
        status: true
    };

    profile: any = {
        id: 0,
        kicker: '',
        title: '',
        description: '',
        status: true
    };

    selectedType = 'features';

    itemModel: any = {
        type: 'features',
        id: 0,
        year: '',
        tag: '',
        title: '',
        description: '',
        sort: 0,
        status: true
    };

    loading = false;
    saving = false;
    errorMessage = '';
    successMessage = '';

    constructor(private adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getAdminAbout().subscribe(
            (res: AdminAboutData) => {
                this.data = res;

                if (res.hero) {
                    this.hero = {
                        id: res.hero.id || 0,
                        eyebrow: res.hero.eyebrow || '',
                        title: res.hero.title || '',
                        description: res.hero.description || '',
                        status: res.hero.status === null || res.hero.status === undefined ? true : res.hero.status
                    };
                }

                if (res.profile) {
                    this.profile = {
                        id: res.profile.id || 0,
                        kicker: res.profile.kicker || '',
                        title: res.profile.title || '',
                        description: res.profile.description || '',
                        status: res.profile.status === null || res.profile.status === undefined ? true : res.profile.status
                    };
                }

                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'About admin data could not be loaded.';
                this.loading = false;
            }
        );
    }

    saveHero(): void {
        this.saving = true;
        this.successMessage = '';
        this.errorMessage = '';

        this.adminApi.saveAboutHero(this.hero).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'About hero saved successfully.';
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'About hero could not be saved.';
            }
        );
    }

    saveProfile(): void {
        this.saving = true;
        this.successMessage = '';
        this.errorMessage = '';

        this.adminApi.saveAboutProfile(this.profile).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'About profile saved successfully.';
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'About profile could not be saved.';
            }
        );
    }

    changeType(type: string): void {
        this.selectedType = type;
        this.newItem();
    }

    getItems(): any[] {
        if (!this.data) {
            return [];
        }

        if (this.selectedType === 'features') {
            return this.data.features || [];
        }

        if (this.selectedType === 'timeline') {
            return this.data.timeline || [];
        }

        return [];
    }

    newItem(): void {
        this.itemModel = {
            type: this.selectedType,
            id: 0,
            year: '',
            tag: '',
            title: '',
            description: '',
            sort: 0,
            status: true
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    editItem(item: any): void {
        this.itemModel = {
            type: this.selectedType,
            id: item.id || 0,
            year: item.year || '',
            tag: item.tag || '',
            title: item.title || '',
            description: item.description || '',
            sort: item.sort || 0,
            status: item.status === null || item.status === undefined ? true : item.status
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    saveItem(): void {
        this.successMessage = '';
        this.errorMessage = '';

        this.itemModel.type = this.selectedType;

        if (!this.itemModel.title) {
            this.errorMessage = 'Title is required.';
            return;
        }

        if (this.selectedType === 'timeline' && !this.itemModel.year) {
            this.errorMessage = 'Year is required for timeline.';
            return;
        }

        this.saving = true;

        this.adminApi.saveAboutItem(this.itemModel).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'About item saved successfully.';
                this.newItem();
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'About item could not be saved.';
            }
        );
    }

    deleteItem(item: any): void {
        if (!confirm('Delete this item?')) {
            return;
        }

        this.adminApi.deleteAboutItem(this.selectedType, item.id).subscribe(
            () => {
                this.successMessage = 'Item deleted.';
                this.loadData();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Item could not be deleted.';
            }
        );
    }

    isTimeline(): boolean {
        return this.selectedType === 'timeline';
    }
}